export function downloadFromBase64(base64Data: string, fileName: string, mimeType: string) {
  const byteCharacters = atob(base64Data)
  const byteNumbers = Array.from({ length: byteCharacters.length })
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.codePointAt(i)
  }
  const byteArray = new Uint8Array(byteNumbers as number[])
  const blob = new Blob([byteArray], {
    type: mimeType,
  })
  const url = globalThis.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = fileName
  document.body.append(a)
  a.click()
  a.remove()
}
